const Util = {
	UpdateUrlHash(hash) {
		// make sure we're dealing with a good hash
		if (typeof hash !== 'undefined') {
			// ensure consistency
			if (hash.indexOf('#') < 0) {
				// eslint-disable-next-line no-param-reassign
				hash = `#${hash}`;
			}

			if (window.history.replaceState) {
				window.history.replaceState(null, null, hash);
			} else {
				window.location.replace(hash);
			}
		}
	},
	GetParameterByName(name, url = window.location.href) {
		// eslint-disable-next-line no-useless-escape
		const n = name.replace(/[\[\]]/g, '\\$&');
		const regex = new RegExp(`[?&]${n}(=([^&#]*)|&|#|$)`);
		const results = regex.exec(url);
		if (!results) return null;
		if (!results[2]) return null;
		return decodeURIComponent(results[2].replace(/\+/g, ' '));
	},
	SetLocalStorage(name, value) {
		if (typeof Storage !== 'undefined') {
			localStorage.setItem(name, value);
		}
	},
	GetLocalStorage(name) {
		if (typeof Storage !== 'undefined') {
			return localStorage.getItem(name);
		}
		return null;
	}
};

export default Util;
